import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
  amount: '',
  isInvalidAmount: false,
};

const usePaymentStore = create(
  devtools(set => ({
    ...initialState,
    setAmount: amount => set({ amount }),
    setIsInvalidAmount: isInvalidAmount => set({ isInvalidAmount }),
  }))
);

export default usePaymentStore;
